export default "__VITE_ASSET__CRkiMdOs__"